module.exports = __webpack_public_path__ + "media/images/new_home/photo-1-2696726cc7a2dd4ee35a1086f02dbf22.jpg";